var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseFilters", {
    attrs: {
      bem: _vm.bemBlock,
      disabled: _vm.loading,
      "filter-display-name": _vm.filterDisplayName,
      options: _vm.options,
      selected: _vm.selected,
      show: _vm.options && _vm.options.length > 1,
      "is-select-multiple": false
    },
    on: { select: _vm.selectFilter },
    scopedSlots: _vm._u([
      {
        key: "optionContent",
        fn: function(slotProps) {
          return [
            _vm._v("\n    " + _vm._s(slotProps.option.displayName) + "\n  ")
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }